export default __webpack_public_path__ + "static/media/BUSDwh.488237bc.svg";